/**
 * @file Sticky
 */
'use strict'

import Common from '../../Utils/Common'

/**
 * @classname Sticky
 * @classdesc Sticky
 */
export default class Sticky {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('Sticky.constructor')
		this._$e = $e
		this.win = $(window);
		this.stickyPosi = $e.offset().top;
		this.side = $('.sticky-side');
		this.stickyWidth = $e.attr('data-width');
		this.stickyMaxWidth = $e.attr('data-max-width');
		this.win.on('scroll', () => this.sticky())
		this.win.on('resize', () => this.sticky())
	}

	/**
	 * クリックのコールバック
	 *
	 * @memberof BtnSpSearch
	 * @return {undefined}
	 */
	 sticky() {
		console.log('Sticky.sticky')
		let w = $(window).width();
		const bp = 768;
		//const max_width = 894;
		let marginTop = '';
		const side_bottom = this.side.offset().top + this.side.outerHeight();

		//pcとspでsticky要素の幅やマージントップを変える
		if (w > bp) {
			marginTop = 70;
		} else {
			marginTop = 50;
		}
		const scroll = this.win.scrollTop() + marginTop;

		//pc:横のオブジェクトが表示されている時に固定となる
		if (w > bp) {
			marginTop = 70;
			if(this.stickyWidth) {
				this._$e.css('width', this.stickyWidth);
			}else {
				this._$e.css('width', 335 + 'px');
			}
			if(this.stickyMaxWidth) {
				this._$e.css('max-width', this.stickyMaxWidth);
			}

			if(scroll > this.stickyPosi && scroll < side_bottom){
				this._$e.addClass('active');
				//横のオブジェクトが上が画面上部に隠れるタイミングで一緒に動く
				if(scroll > side_bottom - this._$e.outerHeight() && scroll < side_bottom){
					this._$e.addClass('sticy_bottom');
				}else {
					this._$e.removeClass('sticy_bottom');
				}
			}else{
				console.log('remove active')
				this._$e.removeClass('active');
			}
		} else {
			marginTop = 50;
			this._$e.css('width', '');
			this._$e.css('max-width', '');
			if(scroll > this.stickyPosi){
				this._$e.addClass('active');
			}else{
				this._$e.removeClass('active');
			}
		}
	}
}
